import styles from "./styles/characters.module.scss";
import { Box, Typography } from "@mui/material";
import { useRouter } from "next/navigation";
import { useCharacters } from "contexts";
import classnames from "classnames";
import { Icon, Image } from "ui";

export function Characters() {
  const { characters, loading } = useCharacters();
  const router = useRouter();

  if (loading || !characters.length) return null;

  return (
    <Box className={styles.root}>
      {characters.slice(0, 9).map((character, index) => (
        <Box
          key={index}
          className={classnames(styles.item, styles.character)}
          onClick={() => router.push(`/characters/${character._id}/`)}
          style={{ backgroundColor: character.color }}
        >
          {character.avatar ? (
            <Image
              alt={character.name}
              height={150}
              src={character.avatar}
              width={150}
            />
          ) : (
            <Typography>{character.name?.charAt(0)}</Typography>
          )}
        </Box>
      ))}
      <Box
        className={classnames(styles.item, styles.add)}
        onClick={() => router.push("/characters/new/")}
      >
        <Icon name="add" />
      </Box>
    </Box>
  );
}
